import { render, staticRenderFns } from "./NewCrash.vue?vue&type=template&id=5559f104&"
import script from "./NewCrash.vue?vue&type=script&lang=js&"
export * from "./NewCrash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports